var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('application-layout',[_c('v-container',[_c('h1',{staticClass:"mb-4"},[_vm._v("Find A Facility")]),_c('facility-list',{attrs:{"type":_vm.type}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }